import React, { useState } from 'react';
import { Col, FormControl, Row } from 'react-bootstrap';
import SelectParameterDropdown from './SelectParameterDropdown';
import BzmIcon from '../../../../../../components/icons/BzmIcon';
import _ from 'lodash';
import SelectOperatorDropdown, { FilterOperator } from './SelectOperatorDropdown';
import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { DataParamFilter } from 'types/rest/assetCatalogTypes';
import i18n from 'i18n';
import EntityModal from 'views/AssetCatalog/Transactions/TransactionEditor/ProcessingActions/stateChange/EntityModal';

type FilterProps = {
  dataParamsList: BlazeDropdownItem[];
  dataParamFilters: DataParamFilter[];
  updateList: (list: DataParamFilter[]) => void;
  isValid: boolean;
  setIsValid: (isValid: boolean) => void;
  createEntityCallBack: (result: any) => void;
};

const FilterByDataParameters = (props: FilterProps) => {
  const getFilterHeader = () => {
    return (
      <Row className={'filterHeader'}>
        <Col md={4}>
          <label htmlFor="">
            {i18n.t('transactions:processingActions.modal.stateChange.filterByDataParameter')}{' '}
            <BzmIcon variant={'bzm-filter'} />
          </label>
        </Col>
        <Col md={2}>
          <label htmlFor="">{i18n.t('transactions:processingActions.modal.stateChange.operator')}</label>
        </Col>
        <Col md={2}>
          <label htmlFor="">{i18n.t('transactions:processingActions.modal.stateChange.value')}</label>
        </Col>
        <Col md={4}></Col>
      </Row>
    );
  };

  const listWithEmptyValues =
    props.dataParamFilters.filter(dpf => dpf.values?.toString().trim() === '').length > 0 ||
    props.dataParamFilters.filter(dpf => dpf.operation === null).length > 0 ||
    props.dataParamFilters.filter(dpf => dpf.key === null).length > 0;

  if (props.isValid === true && listWithEmptyValues === true) {
    props.setIsValid(false);
  }
  if (props.isValid === false && listWithEmptyValues === false) {
    props.setIsValid(true);
  }

  const addFilter = () => {
    const filtersUpdate = _.cloneDeep(props.dataParamFilters);
    filtersUpdate.push({ key: null, operation: null, values: [''] });
    props.updateList(filtersUpdate);
  };

  const deleteFilter = (index: number) => {
    const filtersUpdate = _.cloneDeep(props.dataParamFilters);
    filtersUpdate.splice(index, 1);
    props.updateList(filtersUpdate);
  };

  const getActionIcons = (filter: DataParamFilter, index: number) => {
    const isLast = index == props.dataParamFilters.length - 1;
    const isFirst = index == 0;

    return (
      <>
        {!isFirst && (
          <button
            onClick={() => deleteFilter(index)}
            title="Delete Filter"
            type="button"
            className="btn-circular btn btn-danger"
          >
            <i className="icon-bzm-delete icon"></i>
          </button>
        )}
        {isLast && (
          <button
            onClick={() => addFilter()}
            title="Add new Filter"
            type="button"
            className="btn-circular ml-3 btn btn-secondary"
          >
            <i className="icon icon-bzm-add icon-theme-blue"></i>
          </button>
        )}
      </>
    );
  };

  const onSelectFilterParam = (index: number, selectedParam: BlazeDropdownItem) => {
    const updatedFilters = _.cloneDeep(props.dataParamFilters);
    updatedFilters[index].key = selectedParam.id as string;
    props.updateList(updatedFilters);
  };

  const onChangeOperator = (index: number, operator: FilterOperator | null) => {
    const updatedFilters = _.cloneDeep(props.dataParamFilters);
    updatedFilters[index].operation = operator;
    props.updateList(updatedFilters);
  };

  const onChangeValue = (index: number, value: string, operator: FilterOperator | null) => {
    const updatedFilters = _.cloneDeep(props.dataParamFilters);
    if (operator === FilterOperator.IN_LIST) {
      updatedFilters[index].values = _.split(value, ',');
    } else {
      updatedFilters[index].values = [value];
    }
    props.updateList(updatedFilters);
  };

  const emptyFilter = { value: '', showCreate: false, index: 0 };
  const [newFilter, setNewFilter] = useState(emptyFilter);
  const getFilterRows = () => {
    return (
      <>
        {newFilter.showCreate && (
          <EntityModal
            availableItems={props.dataParamsList.map(dpl => dpl.name)}
            itemName={newFilter.value}
            closeModalAction={() => setNewFilter(emptyFilter)}
            createEntityCallBack={(paramName: any) =>
              props.createEntityCallBack({ key: paramName, id: newFilter.index })
            }
            entityType={'DATA_PARAMETER'}
          />
        )}
        {props.dataParamFilters.map((filter, index) => (
          <Row key={index} className={'mb-3'}>
            <Col md={4}>
              <SelectParameterDropdown
                dataParamsList={props.dataParamsList}
                selectedParamId={filter.key}
                onSelect={(filterParam: BlazeDropdownItem) => onSelectFilterParam(index, filterParam)}
                setModalValue={(entityValue: string) =>
                  setNewFilter({ value: entityValue, showCreate: true, index: index })
                }
              />
            </Col>
            <Col md={2}>
              <SelectOperatorDropdown
                onChangeOperator={(operator: FilterOperator | null) => onChangeOperator(index, operator)}
                selectedOperator={
                  filter.operation !== undefined && filter.operation !== null ? filter.operation.toString() : null
                }
              ></SelectOperatorDropdown>
            </Col>
            <Col md={2}>
              <FormControl
                placeholder="Enter value..."
                value={filter.values.toString()}
                onChange={(e: any) => onChangeValue(index, e.target.value, filter.operation)}
              ></FormControl>
              {filter.operation === FilterOperator.IN_LIST && (
                <div className="text-muted small" style={{ whiteSpace: 'nowrap' }}>
                  {i18n.t('transactions:processingActions.modal.stateChange.operatorInHelp')}
                </div>
              )}
            </Col>
            <Col md={4}>{getActionIcons(filter, index)}</Col>
          </Row>
        ))}
      </>
    );
  };

  return (
    <div className={'mt-4'}>
      {getFilterHeader()}
      {getFilterRows()}
    </div>
  );
};

export default FilterByDataParameters;
